import { useState } from "react";
import { isLogin } from "services/LocalStorage/LocalStorage.service";
import { useDispatch } from "react-redux";
import { AppDispatch } from "store";
import { rateArticle } from "store/userArticle/userArticle.slice";
import { showToast } from "utils/helpers/toastHelper";
import { useNavigate } from "react-router-dom";
import { Rate } from "antd";
import { StarOutlined } from "@ant-design/icons";
import "./RateComponent.scss";

const RateComponent = ({ slug, currentRate }: any) => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const [rate, setRate] = useState(currentRate !== null ? currentRate : 0);

  const handleRate = (slug: string, rate: number) => {
    if (isLogin()) {
      dispatch(rateArticle({ data: { rate: rate }, slug: slug })).then(
        (res: any) => {
          if (res.meta.requestStatus === "fulfilled") {
            showToast(res.payload.data, "success");
            setRate(rate);
          }
        }
      );
    } else {
      showToast(`Niste ulogovani`, "warn");
      navigate("/login");
    }
  };
  return (
    <Rate
      className="Rate"
      character={<StarOutlined />}
      value={rate}
      onChange={(value) => handleRate(slug, value)}
      disabled={!isLogin()}
    />
  );
};

export default RateComponent;
